import React, { Component } from 'react';
import { DialogMessage } from './Widgets/DialogMessage';
import { Loader } from './Widgets/Loader';

export default class SOPMoveRepick extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toteId: '',
            newSlot: '',
            loading: false
        };
        this.closeDialog = this.closeDialog.bind(this);
        this.updateSlot = this.updateSlot.bind(this);
        this.updateSlotCallback = this.updateSlotCallback.bind(this);
        this.displayError = this.displayError.bind(this);
        this.updateToteValue = this.updateToteValue.bind(this);
        this.updateSlotValue = this.updateSlotValue.bind(this);
    }

    componentDidMount() {
        var toteInput = document.getElementById('move-repick-tote-input');
        var slotInput = document.getElementById('move-repick-slot-input');
        var submitButton = document.getElementById('move-repick-submit');
        //when enter is pressed on the tote input, move to the slot input
        toteInput.addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                if (!slotInput.value) {
                    slotInput.focus();
                }
                else {
                    submitButton.click();
                }
            }
        });

        slotInput.addEventListener("keyup", function (event) {
            if (event.keyCode === 13) {
                if (!toteInput.value) {
                    toteInput.focus();
                }
                else {
                    submitButton.click();
                }
            }
        });
    }



    closeDialog() {
        this.setState({
            showDialog: false,
            dialogFullScreen: false,
            dialogContent: "",
            dialogTitle: "",
            isErrorMessage: false
        });
    }

    updateSlot() {
        this.setState({
            loading: true
        });
        this.updateSlotCallback();
    }

    async updateSlotCallback() {
        var putBody = {
            slotId: this.state.newSlot,
            tote: this.state.toteId
        }




        await this.props.makeRESTCall(
            'byusopassignslot',
            'put',
            putBody,
            (putawayRepickData) => {
                if (putawayRepickData.success) {
                    var dialogContent;
                    var dialogTitle;
                    var isErrorMessage = false;
                    if (putawayRepickData.success) {
                        dialogContent = this.state.toteId + ' was succesfully moved to ' + this.state.newSlot;
                        dialogTitle = "SO Successfully Assigned"
                    }
                    else {
                        isErrorMessage = true;
                        dialogContent = putawayRepickData.errMessage;
                        dialogTitle = "Error Moving Repick"
                    }
                    this.setState({
                        dialogTitle: dialogTitle,
                        dialogContent: dialogContent,
                        showDialog: true,
                        loading: false,
                        isErrorMessage: isErrorMessage,
                        toteId: '',
                        newSlot: '',
                    });
                }
                else {
                    this.displayError("Error Moving Repick", putawayRepickData.errMessage);
                }
            },
            (title, error) => {
                this.displayError(title, error);
            },
            () => {
                this.setState({
                    loading: false
                });
            }
        );
    }

    displayError(title, message) {
        this.setState({
            dialogContent: message,
            dialogTitle: title,
            showDialog: true,
            isErrorMessage: true,
            actionDialog: false
        });
    }

    updateToteValue(inputValue) {
        this.setState({
            toteId: inputValue
        });
    }

    updateSlotValue(inputValue) {
        this.setState({
            newSlot: inputValue
        });
    }

    render() {
        return (
            <div>
                {
                    this.state.loading && <Loader />
                }
                <DialogMessage
                    closeDialog={this.closeDialog}
                    showDialog={this.state.showDialog}
                    dialogTitle={this.state.dialogTitle}
                    dialogContent={this.state.dialogContent}
                    isErrorMessage={this.state.isErrorMessage}
                    dialogFullScreen={this.state.dialogFullScreen}
                />
                {
                    this.state.loading && <Loader />
                }
                <h1 className='move-repick-title'>Move Repick Tote</h1>
                <br />
                <h1 className='move-repick-subtitle'>Scan Tote</h1>
                <input autoFocus onChange={(event) => this.updateToteValue(event.target.value)} value={this.state.toteId} id='move-repick-tote-input' className='move-repick-tote-input'></input>
                <h1 className='move-repick-subtitle'>Scan New Slot </h1>
                <input onChange={(event) => this.updateSlotValue(event.target.value)} value={this.state.newSlot} id='move-repick-slot-input' className='move-repick-slot-input'></input>
                <button onClick={(event) => this.updateSlot()} id='move-repick-submit' className='move-repick-submit'>Submit</button>
            </div>
        );
    }
}
